module.exports = __webpack_public_path__ + "img/text_havies_de_ser_ca.4072640b.png";